import { Component, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';

import { ProductsFacade, ProductListItemComponent } from '@ridango/components';
import { AuthService, BaseComponent, CoreFacade, Language, Product } from '@ridango/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'rwidget-product-selector',
    templateUrl: './product-selector.component.html',
    styleUrls: ['./product-selector.component.scss']
})
export class ProductSelectorComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() isEmpty = false;
    @Input() isProductNotAllowed = false;
    @Input() isProductLoginRequired = false;
    @Input() isPersonalizationRequired = false;
    // TODO: check those
    // productNotificationProperty;
    productWithValidityProperty;

    // those are used for WCAG navigation only! Need crash course on WCAG navigation (HK)
    selectedProduct;
    filteredProducts;

    filteredProducts$ = this.productsFacade.filteredProducts$;
    selectedProduct$ = this.productsFacade.selected$;
    selectedLanguage$: Observable<Language> = this.coreFacade.selectedLanguage$;

    @Input() locale = 'en';
    @Input() step;
    @ViewChildren(ProductListItemComponent) focusItems: QueryList<any>;

    constructor(
        private productsFacade: ProductsFacade,
        private readonly authService: AuthService,
        private translate: TranslateService,
        private router: Router,
        private coreFacade: CoreFacade
    ) {
        super();
    }

    ngOnInit() {
        this.filteredProducts$.pipe(takeUntil(this.componentDestroyed$)).subscribe((p) => {
            this.filteredProducts = p;
        });

        this.selectedLanguage$.pipe(takeUntil(this.componentDestroyed$)).subscribe((l) => {
            if (l?.code) {
                this.locale = l.code;
            }
        });

        this.selectedProduct$.pipe(takeUntil(this.componentDestroyed$)).subscribe((p) => {
            this.selectedProduct = p;
        });
    }

    productSelected(product: Product) {
        this.productsFacade.setSelectedProduct(product);
    }

    selectLeft(p: Product) {
        this.setFocusToSibling(p, -1);
    }

    selectRight(p: Product) {
        this.setFocusToSibling(p, 1);
    }

    setFocusToSibling(p: Product, direction: number) {
        let destElId;
        this.filteredProducts.some((fp, i) => {
            if (fp.product_id === p.product_id) {
                destElId = i + direction;
                return true;
            }
        });
        if (destElId < 0) {
            destElId = this.focusItems.length - 1;
        } else if (destElId >= this.focusItems.length) {
            destElId = 0;
        }
        this.productSelected(this.filteredProducts[destElId]);
        setTimeout(() => this.focusItems.toArray()[destElId].productItem.nativeElement.focus());
    }

    focus(p: Product) {
        this.focusItems.toArray()[this.findElementIndex(p)].productItem.nativeElement.classList.add('focus');
        if (this.selectedProduct) {
            // If some item already selected, focusing on item selects
            this.productSelected(p);
        }
    }

    blur(p: Product) {
        this.focusItems.toArray()[this.findElementIndex(p)].productItem.nativeElement.classList.remove('focus');
    }

    findElementIndex(p: Product) {
        return this.filteredProducts.findIndex((fp: Product) => fp.product_id === p.product_id);
    }

    getTabIndex(p: Product) {
        if (this.selectedProduct) {
            if (this.selectedProduct.product_id === p.product_id) {
                // Selected item
                return 0;
            }
        } else if (this.filteredProducts[0].product_id === p.product_id) {
            // First item
            return 0;
        }
        return -1;
    }

    getProductInfoProperty(product) {
        if (!product) {
            return false;
        }
        return product.product_properties.find((pp) => {
            return pp.code === 'PRODUCT_ADDITIONAL_INFORMATION';
        });
    }

    goToLoginPage() {
        this.router.navigate([this.translate.currentLang, 'login'], {
            queryParams: {
                redirect: '/purchase/ticket'
            }
        });
    }
    goToProfilePage() {
        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
    }

    checkIfJointTicket(product: Product): boolean {
        if (!product) return false;

        return product.product_properties?.some((prop) => prop.code === 'DYNAMIC_LENGTH') ?? false;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
